import { Head } from "@inertiajs/react"

import { DocumentTable } from "@/components/dashboard/document-table"
import { EmptyState } from "@/components/dashboard/empty-state"
import AppLayout from "@/layouts/app-layout"
import { documentsPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

interface Document {
  id: number
  filename: string
  operation_type: string | null
  status: "pending" | "processing" | "completed" | "failed"
  size: number | null
  created_at: string
  expires_at: string | null
  expired: boolean
  download_url: string | null
}

interface DocumentsIndexProps {
  documents: Document[]
  plan: "free" | "plus" | "pro"
}

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Documents",
    href: documentsPath(),
  },
]

export default function DocumentsIndex({
  documents,
  plan,
}: DocumentsIndexProps) {
  const hasDocuments = documents.length > 0

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Documents" />

      <div className="flex h-full flex-1 flex-col overflow-hidden">
        <div className="flex-1 overflow-y-auto p-4">
          <div className="flex flex-col gap-4">
            {hasDocuments ? (
              <DocumentTable documents={documents} plan={plan} />
            ) : (
              <EmptyState />
            )}
          </div>
        </div>
      </div>
    </AppLayout>
  )
}
